import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject } from 'vue';
import { StCol } from './grid.styled';
import { gridColProps, injectionKey } from './grid.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkCol',
  props: gridColProps,
  setup(__props) {


const injectedProps = inject(injectionKey);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StCol), _mergeProps({ as: _ctx.as }, {..._ctx.$props}, {
    gutter: _unref(injectedProps).gutter,
    columns: _unref(injectedProps).columns,
    grow: _unref(injectedProps).grow
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["as", "gutter", "columns", "grow"]))
}
}

})